import React, { useState, useRef } from 'react';
import axios from 'axios';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { Box, Typography, Stack } from '@mui/material';
import { API_URL } from '../../../../links/API_LINKS';
import QuestionForm from './QuestionForm';
import { useQueryClient } from 'react-query';

const CreateNewQuestion = ({ setValue }) => {
  const queryClient = useQueryClient();

  const formikRef = useRef();
  const [serverResponse, setServerResponse] = useState();

  return (
    <div>
      <Box>
        <Typography variant='h6'>Add a new Question</Typography> <br />
      </Box>
      <div>
        <Formik
          enableReinitialize={true}
          innerRef={formikRef}
          initialValues={{
            question: '',
            type: 'GENERAL',
            domain: '',
            category: '',
            image: [],
            time: '',
            options: [
              {
                option: '',
                value: 0,
              },
            ],
            maxSelect: 1,
            skill: null,
          }}
          validationSchema={Yup.object({
            question: Yup.string().required('Please enter a Question'),
            domain: Yup.string().when('type', {
              is: 'DOMAIN',
              then: Yup.string().required('Please select a Domain.'),
            }),
            category: Yup.string()
              .when('type', {
                is: 'MASTERCLASS',
                then: Yup.string().required('Please select a category.'),
              })
              .nullable(),
            time: Yup.string()
              .when('type', {
                is: 'MASTERCLASS',
                then: Yup.string().required('Please enter Time.'),
              })
              .nullable(),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const updatedData = { ...values }; //new added
            if (values.type === 'GENERAL') {
              delete updatedData.domain;
              delete updatedData.image;
              delete updatedData.skill;
              delete updatedData.category;
              delete updatedData.time;
            }
            if (values.type === 'DOMAIN') {
              delete updatedData.image;
              delete updatedData.category;
              delete updatedData.time;
            }
            if (values.type === 'MASTERCLASS') {
              delete updatedData.domain;
              delete updatedData.skill;
            }

            setServerResponse('');
            axios({
              method: 'POST',
              url: API_URL + '/question',
              data: updatedData,
            })
              .then(function (response) {
                queryClient.invalidateQueries('fetchQuestion');
                setServerResponse('Question added successfully');

                setSubmitting(false);
                response.data.status === 'success' && resetForm();
              })
              .catch(function (response) {
                setServerResponse('Error! Could not process your request.');
                setSubmitting(false);
              });
          }}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <QuestionForm values={values} setFieldValue={setFieldValue} />
              <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                spacing={3}
                mt={2}
              >
                <LoadingButton
                  type='submit'
                  variant='contained'
                  loading={isSubmitting}
                >
                  Add Question
                </LoadingButton>
              </Stack>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  p: 1,
                  m: 1,
                }}
              >
                {serverResponse && <Typography>{serverResponse}</Typography>}
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateNewQuestion;
